<template>
  <div>
    <CarouselComponent/>
    <HomeDividerText/>
    <HomeCards/>
    <Footer/>
    <Popup/>
  </div>
</template>

<script>
import CarouselComponent from "@/component/user/home/carousel/CarouselComponent";
import HomeDividerText from "@/component/user/home/HomeDividerText";
import HomeCards from "@/component/user/home/HomeCards";
import Footer from "@/component/user/Footer.vue";
import Popup from "@/component/user/home/Popup.vue";

export default {
  name: 'Home',
  components: {
    Footer,
    CarouselComponent,
    HomeDividerText,
    HomeCards,
    Popup
  }
}
</script>

<style scoped>
* {
  background: #F0EAD6;
}
</style>
